import toaster from '@/toaster';
import { AxiosError } from 'axios';
import i18n from 'i18next';

interface ErrorResponse {
  statusCode: number;
  timestamp: string;
  path: string;
  message: string;
  errors: string[];
}

export const globalErrorHandler = (error: AxiosError) => {
  const errorResponse = error.response?.data as ErrorResponse;

  if (errorResponse.message === 'password_reset_required') {
    return toaster.error(i18n.t('passwordResetRequired'));
  }

  if (errorResponse) {
    toaster.error(errorResponse.errors.join(', '));
  }
};
